<!-- 
Contents of the HISTORY tab of the notice template page.
-->
<template>
  <div>
    <our-heading
      :breadcrumbs="breadcrumbs"
      :title="title"
      user-guide-topic="levy-collection-setup"
      user-guide-section="notice-templates"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :levy-collection-id="levyCollectionId" :notice-type="noticeType" :can-edit="canEdit" path="history">
      <our-search-button 
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search notice template history"
        flat
        show-all
        @changed="$refs.history.refresh()"
      />
      <our-saved-searches-menu
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="systemLogs" 
        color="primary"
        flat dense
        @selected="$refs.history.refresh()"
      />
      <system-log-listing
        ref="history"
        :endpoint="`/api/levy-collections/${levyCollectionId}/notice-templates/${noticeType}/history`" 
        :export-endpoint="`/api/exports/levy-collections/${levyCollectionId}/notice-templates/${noticeType}/history`"
        :export-validate-endpoint="`/api/exports/validate/levy-collections/${levyCollectionId}/notice-templates/${noticeType}/history`"
        embedded 
      />
    </tabs>
  </div>
</template>

<script>
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import Tabs from "./Tabs.vue";
import noticeTemplateMixins from "./mixins";
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  name: "NoticeTemplateHistory",
  components: { LevyCollectionNavigator, SystemLogListing, Tabs },
  mixins: [noticeTemplateMixins],
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters("LevyCollectionTemplateAction", true);
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  }
};
</script>
